import { useEffect, useRef } from "react";
import { fill, useTexts } from "../texts.js";
import { useToast } from "../Toast.js";
import { learningProgress, visibleTasks } from "./learning.js";
/**
 * Toasts a learning-path milestone: "Gelernt: <task>" with the progress and
 * a button to the path, or "Lernpfad abgeschlossen" for the last task.
 * Needs a ToastProvider above.
 */
export function useLearningMilestones(store, tasks, { admin = false, ignore = [], onOpenPath, } = {}) {
    const t = useTexts();
    const toast = useToast();
    const opts = useRef({ tasks, ignore, onOpenPath, t });
    opts.current = { tasks, ignore, onOpenPath, t };
    useEffect(() => store.onComplete((e) => {
        const { tasks: all, ignore: skip, onOpenPath: open, t: tx } = opts.current;
        if (skip.includes(e))
            return;
        const mine = visibleTasks(all, admin);
        const task = mine.find((x) => x.event === e);
        if (!task)
            return;
        const p = learningProgress(store.snapshot(), mine);
        if (p.done === p.total) {
            toast.success(tx.learnedAllTitle, tx.learnedAllText);
            return;
        }
        toast.success(fill(tx.learnedTitle, { title: task.title }), fill(tx.learnedProgress, { done: p.done, total: p.total }), open ? { label: tx.helpPath, run: open } : undefined);
    }), [store, admin, toast]);
}
